import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class IntroAnt extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.body = ABCyaPhaser.Images.addImage(0, 0, 'big-ant-body', this).setOrigin(.5, 1);
    this.eyes = ABCyaPhaser.Images.addImage(0, 0, 'eyes-idle', this).setOrigin(.5, 1);
    this.eyes.x = 65;
    this.eyes.y = -205;

    this.eyeAnimDelay = Math.round(Phaser.Math.Between(100,300));

    this.swayBounce();
  }

  swayBounce() {
    this.scene.tweens.killTweensOf(this);

    const endScale = this.scaleY < 1 ? 1 : Phaser.Math.Between(95,98) / 100;
    const endRotation = Phaser.Math.Between(-2,2);
    const time = Phaser.Math.Between(400,800);

    ABCyaPhaser.Tweens.addTween(this, time, { scaleY: endScale, angle: endRotation }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.swayBounce();
    });
  };

  tick() {
    this.eyeAnimDelay--;
    if (this.eyeAnimDelay <= 0) {
      this.eyeAnimDelay = Math.round(Phaser.Math.Between(100,300));
      this.eyes.setFrame('eyes-blink_2');
      this.scene.time.delayedCall(100, () => {this.eyes.setFrame('eyes-idle');});
    }
  };
}